import { useCallback } from 'react'

/**
 * Hook per feedback vibrazione su dispositivi mobili
 * 
 * @returns {Object} { vibrate, vibrateSuccess, vibrateError, vibrateWarning }
 */
export function useVibrate() {
  // Verifica supporto
  const isSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator

  // Vibrazione generica
  const vibrate = useCallback((pattern = 50) => {
    if (isSupported) {
      try {
        navigator.vibrate(pattern)
      } catch (e) {
        console.warn('Vibrazione non supportata:', e)
      }
    }
  }, [isSupported])

  // Vibrazione successo (breve)
  const vibrateSuccess = useCallback(() => {
    vibrate([50])
  }, [vibrate])

  // Vibrazione errore (lunga)
  const vibrateError = useCallback(() => {
    vibrate([100, 50, 100])
  }, [vibrate])

  // Vibrazione warning (doppia)
  const vibrateWarning = useCallback(() => {
    vibrate([50, 30, 50])
  }, [vibrate])

  return { 
    vibrate, 
    vibrateSuccess, 
    vibrateError, 
    vibrateWarning,
    isSupported 
  }
}

export default useVibrate
